import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "next-themes";
import "@/design/tokens.css";
import "@/index.css";
import "@/panel.css";
import App from "@/App";
import { warmFonts } from "@/lib/warmFonts";

warmFonts(document);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);
